<script setup lang="ts">
import { RouterView } from 'vue-router'
import { useChatStore } from '@/stores/chat'
import { useSessionStore } from '@/stores/session'
import { useSecurityPromptStore } from '@/stores/securityPrompt'
import { onMounted } from 'vue'
import MerMemberFloatingBar from '@/components/MerMemberFloatingBar.vue'
import SecurityPromptHost from '@/components/security/SecurityPromptHost.vue'
import BroadcastPopup from '@/components/BroadcastPopup.vue'

const chatStore = useChatStore()
const sessionStore = useSessionStore()
const securityPromptStore = useSecurityPromptStore()

onMounted(async () => {
  chatStore.connectWebSocket()
  if (sessionStore.sessionId) {
    await securityPromptStore.checkAndEnqueue()
  }
})
</script>

<template>
  <RouterView />
  <MerMemberFloatingBar />
  <SecurityPromptHost />
  <BroadcastPopup />
</template>

<style scoped></style>
